module.exports = __webpack_public_path__ + "img/840.037af82c.svg";